import { ReactNode } from 'react';
import { Grid } from '../../../../../../ui/grid/Grid';

type Props = {
    headline?: ReactNode;
    content?: ReactNode;
    footer?: ReactNode;
    contentGrow?: boolean;
};

const Column = ({ headline, content, footer, contentGrow }: Props) => (
    <Grid.Wrapper type="rows">
        {headline && <Grid.Element type="row" padding>{headline}</Grid.Element>}
        {headline && content && <Grid.Element type="sep" padding />}
        {content && <Grid.Element type="row" padding grow={contentGrow ?? true}>{content}</Grid.Element>}

        {footer}
    </Grid.Wrapper >
);

export default Column;